import { ItemList } from '../../orm'

class AdminEditableSettingList extends ItemList {
    getEntityKey() {
        return "admin/editable_setting"
    }
}

export const adminEditableSettingList = new AdminEditableSettingList("admin_editable_setting__default")
